import * as net from 'util/Net';

import {AnalyticsDashboardSpecRequest, AnalyticsDashboardSpecResponse} from './RESTAnalyticsDashboardTypes';

export function createAnalyticsDashboard(
  data: AnalyticsDashboardSpecRequest
): Promise<AnalyticsDashboardSpecResponse> {
  return net.postJSONPromise({
    url: '/1/api/analytics-dashboards',
    data,
  });
}

export function updateAnalyticsDashboard(
  analyticsDashboardId: string,
  data: AnalyticsDashboardSpecRequest
): Promise<AnalyticsDashboardSpecResponse> {
  return net.patchJSONPromise({
    url: `/1/api/analytics-dashboards/${analyticsDashboardId}`,
    data,
  });
}

export function deleteAnalyticsDashboard(analyticsDashboardId: string): Promise<{}> {
  return net.deletePromise({
    url: `/1/api/analytics-dashboards/${analyticsDashboardId}`,
  });
}

export function cloneAnalyticsDashboard(
  analyticsDashboardId: string,
  data: {projectId: string}
): Promise<AnalyticsDashboardSpecResponse> {
  return net.postJSONPromise({
    url: `/1/api/analytics-dashboards/${analyticsDashboardId}:clone`,
    data,
  });
}

export function starAnalyticsDashboards(analyticsDashboardIds: Array<string>): Promise<void> {
  return net.postJSONPromise({
    url: '/1/api/analytics-dashboards:star',
    data: {analyticsDashboardIds},
  });
}

export function unstarAnalyticsDashboards(analyticsDashboardIds: Array<string>): Promise<void> {
  return net.postJSONPromise({
    url: '/1/api/analytics-dashboards:unstar',
    data: {analyticsDashboardIds},
  });
}
